import { useState } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import DashboardNavbar from "./dashboard-navbar";
import { DashboardSidebar } from "./dashboard-sidebar";

const DashboardLayoutRoot = styled("div")(({ theme }) => ({
    display: "flex",
    flex: "1 1 auto",
    maxWidth: "100%",
    paddingTop: 64, // Giữ nguyên khoảng cách ở trên đỉnh
    [theme.breakpoints.up("lg")]: {
        paddingLeft: 0 // QUAN TRỌNG: Sửa thành 0 để nội dung tràn ra giữa, không bị lệch phải nữa
    }
}));

export const DashboardLayout = (props) => {
    const { children } = props;
    const [state, setState] = useState();
    
    const parentCallback = (data) => {
        setState(data);
    };
    const parentCallback1 = (data) => {
        setState(data);
    };
    
    return (
        <>
            {/* 1. ĐƯA THANH NAV LÊN TRÊN CÙNG Ở ĐÂY */}
            <DashboardNavbar callback={parentCallback} />
            <DashboardSidebar
                show={props.customer}
                callback={parentCallback1}
                open={state}
            />

            {/* 2. NỘI DUNG (DASHBOARD) NẰM BÊN DƯỚI */}
            <DashboardLayoutRoot>
                <Box
                    sx={{
                        display: "flex",
                        flex: "1 1 auto",
                        flexDirection: "column",
                        width: "100%"
                    }}>
                    {children}
                </Box>
            </DashboardLayoutRoot>
        </>
    );
};